import React from "react"
import propTypes from "prop-types"
import { connect } from "react-redux"
import {
  fetchSupportRequests,
  toggleEndorsement,
  archiveSuggestions
} from "../../../../../../services/plans"
import configs from "../../../../../../configs"

import Messages from "../../../../components/Messages"

import iconClipboardList from "./images/icon-clipboard-list.svg"
import iconHappy from "./images/icon-happy.svg"
import iconStar from "./images/icon-star.svg"
import iconUserCircle from "./images/icon-user-circle.svg"
import iconUserFriends from "./images/icon-user-friends.svg"

class Suggestions extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      showSuggestionsForIsHidden: true,
      showSuggestionsForCurrent: "AM",
      showSuggestionsForList: [
        {
          id: 0,
          title: "About Me",
          value: "AM",
          icon: iconUserCircle
        },
        {
          id: 1,
          title: "My Support Team",
          value: "ST",
          icon: iconUserFriends
        },
        {
          id: 2,
          title: "Community Activities",
          value: "CA",
          icon: iconHappy
        },
        {
          id: 3,
          title: "My Goals",
          value: "MG",
          icon: iconStar
        },
        {
          id: 4,
          title: "Required Services",
          value: "RS",
          icon: iconClipboardList
        }
      ],
      suggestionsFilterValue: "new"
    }
  }

  componentDidMount() {
    this.handlFetchSupportRequests()
  }

  handlFetchSupportRequests = () => {
    const {
      onFetchSupportRequests,
      store: { user, planId }
    } = this.props

    const { showSuggestionsForCurrent, suggestionsFilterValue } = this.state

    onFetchSupportRequests(
      user.token,
      showSuggestionsForCurrent,
      planId,
      suggestionsFilterValue
    )
  }

  onChangeSuggestionsFor = (e, value) => {
    e.preventDefault()

    this.setState(
      {
        showSuggestionsForCurrent: value
      },
      () => {
        this.handlFetchSupportRequests()
      }
    )
  }

  getFilteredSuggestions = value => {
    this.setState(
      {
        suggestionsFilterValue: value
      },
      () => {
        this.handlFetchSupportRequests()
      }
    )
  }

  toggleSidebarFilters = name => {
    const { showSuggestionsForIsHidden } = this.state

    const current = {
      showSuggestionsForIsHidden
    }

    this.setState({ [name]: !current[name] })
  }

  getSuggestionsMessages = () => {
    const {
      store: { supportRequests }
    } = this.props

    const suggestionsMessages = []

    if (supportRequests) {
      if (
        Object.keys(supportRequests).length !== 0 &&
        supportRequests.constructor === Object
      ) {
        supportRequests.plan_section_entities.data.map(dataItem => {
          if (dataItem) {
            dataItem.suggestions.map(suggestion => {
              suggestionsMessages.push({
                type: "suggestion",
                endorsements: suggestion.endorsements,
                id: suggestion.id,
                createdAt: suggestion.created_at,
                createdAtDisplay: suggestion.created_at_display,
                title: `${
                  configs.plan_section[supportRequests.plan_section]
                } support suggestion`,
                subtitle: `${suggestion.guardian.first_name} \u00A0 ${suggestion.title}`,
                firstName: suggestion.guardian.first_name,
                content: suggestion.content
              })

              return null
            })
          }

          return null
        })
      }
    }

    return suggestionsMessages
  }

  handleToggleEndorsement = suggestionId => {
    const {
      store: { user },
      onToggleEndorsement
    } = this.props

    onToggleEndorsement(user.token, suggestionId).then(() => {
      this.handlFetchSupportRequests()
    })
  }

  handleArchiveSuggestions = (id, planSection) => {
    const {
      store: { user },
      onArchiveSuggestions
    } = this.props

    if (id) {
      onArchiveSuggestions(user.token, {
        id,
        planSection
      }).then(() => {
        this.handlFetchSupportRequests()
      })
    }
  }

  render() {
    const {
      showSuggestionsForIsHidden,
      showSuggestionsForCurrent,
      showSuggestionsForList,
      suggestionsFilterValue
    } = this.state
    const {
      store: {
        supportRequestsLoading,
        endorsementLoading,
        archiveSuggestionsLoading,
        user
      }
    } = this.props

    const filterOptions = [
      {
        value: "new",
        label: "New Suggestions"
      },
      {
        value: "endorsement",
        label: "Most endorsements"
      }
    ]

    const participant = user.list_role.includes(configs.roles.Participant)

    return (
      <div className="activity">
        <div className="content">
          <div className="container">
            <div className="row">
              <div className="col-md-10 offset-md-1">
                <div className="row">
                  <div className="col-lg-4">
                    <div className="activity_sidebar">
                      <div className="activity_sidebar_section">
                        <div className="activity_sidebar_title">
                          Show results for
                        </div>
                        <button
                          onClick={() => {
                            this.toggleSidebarFilters(
                              "showSuggestionsForIsHidden"
                            )
                          }}
                          type="button"
                          className="activity_sidebar_title_btn"
                        >
                          Show results for
                        </button>

                        <div
                          className={`activity_sidebar_list ${
                            showSuggestionsForIsHidden
                              ? "activity_sidebar_list--hidden"
                              : ""
                          }`}
                        >
                          <ul>
                            {showSuggestionsForList.map(
                              ({ title, icon, value, id }) => (
                                <li
                                  className="activity_sidebar_list_item"
                                  key={`show-activities-for-${id}`}
                                >
                                  <a
                                    className={`activity_sidebar_list_link ${
                                      showSuggestionsForCurrent === value
                                        ? "activity_sidebar_list_link--active"
                                        : ""
                                    }`}
                                    href="/#"
                                    onClick={e => {
                                      this.onChangeSuggestionsFor(e, value)
                                    }}
                                  >
                                    <img
                                      className="activity_sidebar_list_icon"
                                      src={icon}
                                      title={title}
                                      alt={title}
                                    />
                                    {title}
                                  </a>
                                </li>
                              )
                            )}
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-8">
                    <Messages
                      messages={this.getSuggestionsMessages()}
                      loading={supportRequestsLoading}
                      isParticipant={participant}
                      filterOptions={filterOptions}
                      onFilterChange={this.getFilteredSuggestions}
                      filterValue={suggestionsFilterValue}
                      onToggleEndorsement={this.handleToggleEndorsement}
                      onArchiveSuggestions={this.handleArchiveSuggestions}
                      endorsementLoading={endorsementLoading}
                      archiveSuggestionsLoading={archiveSuggestionsLoading}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

Suggestions.propTypes = {
  onFetchSupportRequests: propTypes.func.isRequired,
  onToggleEndorsement: propTypes.func.isRequired,
  onArchiveSuggestions: propTypes.func.isRequired,
  store: propTypes.shape({
    user: propTypes.shape({
      token: propTypes.string,
      list_role: propTypes.arrayOf(propTypes.number)
    }),
    supportRequests: propTypes.shape({
      help_request: propTypes.any,
      plan_section_entities: propTypes.shape({
        data: propTypes.arrayOf(propTypes.shape({}))
      }),
      plan_section: propTypes.string
    }),
    endorsementLoading: propTypes.bool,
    supportRequestsLoading: propTypes.bool,
    archiveSuggestionsLoading: propTypes.bool,
    planId: propTypes.oneOfType([propTypes.string, propTypes.number])
  }).isRequired
}

Suggestions.defaultProps = {}

const mapStateToProps = ({ AuthenticationReducer, PlansReducer }) => ({
  store: {
    user: AuthenticationReducer.user,
    supportRequests: PlansReducer.supportRequests,
    supportRequestsLoading: PlansReducer.supportRequestsLoading,
    endorsementLoading: PlansReducer.endorsementLoading,
    archiveSuggestionsLoading: PlansReducer.archiveSuggestionsLoading,
    planId: PlansReducer.id
  }
})

const mapDispatchToProps = dispatch => ({
  onFetchSupportRequests: (token, sectionCode, planId, filter) =>
    dispatch(fetchSupportRequests(token, sectionCode, planId, filter)),
  onToggleEndorsement: (token, suggestionId) =>
    dispatch(toggleEndorsement(token, suggestionId)),
  onArchiveSuggestions: (token, obj, action) =>
    dispatch(archiveSuggestions(token, obj, action))
})

export default connect(mapStateToProps, mapDispatchToProps)(Suggestions)
